import React from "react"
import { GridThemeProvider } from "styled-bootstrap-grid"
import Layout from "../layout/index"
import Promo from "../components/sections/promo"
import Benefits from "../components/sections/benefits"
import Features from "../components/sections/features"
import Steps from "../components/sections/steps"
import Calculator from "../components/sections/calculator"
import Subscription from "../components/sections/subscription"
import SEO from "../components/seo"
import Cookie from "../components/cookie"
import "./index.css"
import "../styles/style.sass"

const gridTheme = {
  gridColumns: 12,
  breakpoints: {
    xl: 1200,
    lg: 1024,
    md: 768,
    sm: 576,
    xs: 575,
  },
  row: {
    padding: 10,
  },
  col: {
    padding: 10,
  },
  container: {
    padding: 20,
    maxWidth: {
      xl: 1220,
      lg: 1220,
      md: 1024,
      sm: 768,
      xs: 576,
    },
  },
}

function App() {
  return (
    <GridThemeProvider gridTheme={gridTheme}>
      <Layout>
        <SEO
          title="Корпоративная пенсионная программа Антикризис"
          description="Сократите расходы на финансовую мотивацию сотрудников, предложив им достойную альтернативу. Рассчитайте экономию для бизнеса за 10 секунд."
        />
        <Promo />
        <Benefits />
        <Features />
        <Steps />
        <Calculator />
        <Subscription />
        <Cookie />
      </Layout>
    </GridThemeProvider>
  )
}

export default App
